import * as React from "react";
import { useGoogleMapsModule } from "../../../GoogleMaps/external-module.js";
const InfoWindow = ({ options: optionsProp, ...props }) => {
  const [ReactGoogleMaps] = useGoogleMapsModule();
  if (!ReactGoogleMaps) {
    return null;
  }
  const options = { ...optionsProp, pixelOffset: void 0 };
  if (optionsProp?.pixelOffset) {
    options.pixelOffset = {
      ...optionsProp.pixelOffset,
      equals: optionsProp.pixelOffset.equals ? optionsProp.pixelOffset.equals : () => false
    };
  }
  return /* @__PURE__ */ React.createElement(ReactGoogleMaps.InfoWindow, { options, ...props });
};
export {
  InfoWindow
};
//# sourceMappingURL=InfoWindow.js.map
